var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{key:_vm.iconName,staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.iconName])},on:{"click":function($event){return _vm.$emit('click', $event)},"mousedown":function($event){return _vm.$emit('mousedown', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }